<template>
    <div>
        <el-button v-on:click="backHistory">返回</el-button>
        <div class="infoDetailBox">
            权重数：N=　
            <input type="text" v-model="weight">
            (浮点数)
        </div>
        <el-row class="button-row">
            <el-button type="success" round style="margin-right:10px;" @click.native="onSubmit()">保存</el-button>
            <el-button type="info" round v-on:click="backHistory">返回</el-button>
        </el-row>
    </div>
</template>

<script>
import { weightList, weightUpd } from "../../api/posting/posting";
// import { weightList, postingDetail } from "../../api/posting/posting";

export default {
    data() {
        return {
            weight: ""
        };
    },
    methods: {
        backHistory(){
            this.$router.go(-1);//返回上一层
        },
        getList() {
            weightList()
                .then(response => {
                    var data = response.data;
                    this.loading = false;
                    this.weight = data.weight;
                })
                .catch(() => {
                    this.weight = "";
                });
        },
        onSubmit() {
            this.loading = true;
            // 修改权重的值
            weightUpd( {
                num: this.weight
            }).then(response => {
                console.log(response,'33333333333333');
                if (response.code == 0) {
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                    // this.$router.push({ path: `/openScreen/openScreen` })
                }
            }).catch((res) => {
                this.loading = false;
                this.$message( {
                    message: "修改失败:" + res.msg,
                    type: "error"
                });
            });
        },
    },
    created() {
        sessionStorage.setItem( "currentPage_advertList", 1);
        sessionStorage.setItem( "currentPage_findVideoList", 1);
        sessionStorage.setItem( "currentPage_findList", 1);
        sessionStorage.setItem( "currentPage_messageList", 1);
        sessionStorage.setItem( "currentPage_normalUsersAdmin", 1);
        sessionStorage.setItem( "currentPage_userList", 1);
        sessionStorage.setItem( "currentPage_editorList", 1);
        // 加载数据
        this.getList();
    },
    filters: {
        //时间转换 用到moment.js
        formatDate: function(value) {
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        }
    }
};
</script>

<style type="text/scss" lang="scss">
div {
    font-size: 14px;
}
p {
    font-size: 14px;
}
.infoDetailBox {
    display: flex;
    box-sizing: border-box;
    padding: 35px 50px;
    border-bottom: 1px solid #dddddd;
    position: relative;
    div {
        width: 45%;
    }
}
.gcDetails {
    box-sizing: border-box;
    padding: 15px 50px;
    border-bottom: 1px solid #dddddd;
    > div {
        display: flex;
    }
}
.gcDetails > div > :nth-child(2) {
    margin-left: 50px;
}
.chakandetail {
    color: #2490fa;
    cursor: pointer;
    margin-left: 10px;
}
.jlSpan {
    margin-left: 35px;
}
.imgsDiv {
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
    width: 525px;
    img {
        margin-right: 10px;
        margin-bottom: 10px;
    }
}
</style>
